/// <amd-module name="SuiteCommerce.GiftCertificate.LandingPage.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.LandingPage.Configuration", ["require", "exports", "SuiteCommerce.GiftCertificate.Utils.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LandingPageConfiguration = void 0;
    var LandingPageConfiguration = /** @class */ (function (_super) {
        __extends(LandingPageConfiguration, _super);
        function LandingPageConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(LandingPageConfiguration, "landingPageTitle", {
            get: function () {
                return this.get('giftcertbalance.title');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LandingPageConfiguration, "landingPageRoute", {
            get: function () {
                return this.get('giftcertbalance.route');
            },
            enumerable: false,
            configurable: true
        });
        return LandingPageConfiguration;
    }(Configuration_1.Configuration));
    exports.LandingPageConfiguration = LandingPageConfiguration;
});
